import React from "react";

const RangeSurveyInput = ({
  dimensionIndex,
  questionIndex,
  handleChange,
  defaultAnswer,
  labels,
  less,
  start,
  end,
  more,
}) => {
  const renderOption = (optionIndex) => {
    const rangedValue = end > start ? start + optionIndex : start - optionIndex;
    const label = labels && labels[rangedValue] ? labels[rangedValue] : "";

    return (
      <option
        key={`survey-question-field-range-${dimensionIndex}_${questionIndex}-option-${optionIndex}`}
        value={rangedValue}
      >
        {`${rangedValue} ${label && `(${label})`}`}
      </option>
    );
  };

  return (
    <div className="form-group dropdown">
      <select className="custom-select" value={defaultAnswer ?? ""} onChange={handleChange}>
        {/* POR DEFECTO */}
        <option value="">Seleccione una opción</option>

        {/* OPCIÓN MENOS DE... */}
        {less && <option value={less}>{less}</option>}

        {/* EL LISTADO DE OPCIONES */}
        {[...Array(Math.abs(end - start + 1))].map((_, optionIndex) => renderOption(optionIndex))}

        {/* OPCIÓN MAS DE ... */}
        {more && <option value={more}>{more}</option>}
      </select>
    </div>
  );
};

export default RangeSurveyInput;
